module.exports = __webpack_public_path__ + "static/media/4.fa356b7d.png";